<template>
  <simple-modal :visible="visible || loading" @close="cancel">
    <div @click.stop>
      <slot></slot>
    </div>
    <div class="flex flex-nowrap items-center justify-between" @click.stop>
      <p
        class="capitalize"
        :class="loading ? 'pointer-events-none invisible' : 'cursor-pointer'"
        @click="cancel"
      >
        {{ cancelText }}
      </p>
      <div class="ml-auto">
        <default-button
          :disabled="!canConfirm"
          :color="danger ? 'red' : 'blue'"
          :loading="loading"
          @click="confirm"
          ><p class="capitalize">{{ confirmText }}</p></default-button
        >
      </div>
    </div>
  </simple-modal>
</template>
<script>
import DefaultButton from "../Buttons/DefaultButton.vue";
import SimpleModal from "@/components/Modals/SimpleModal.vue";
export default {
  name: "ConformationModal",
  components: { SimpleModal, DefaultButton },
  props: {
    visible: Boolean,
    confirmText: {
      type: String,
      default: "",
    },
    cancelText: {
      type: String,
      default: "",
    },
    loading: Boolean,
    danger: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["cancel", "confirm"],
  data() {
    return {
      canConfirm: true,
    };
  },
  mounted() {
    if (this.danger) {
      this.canConfirm = false;
      setTimeout(() => {
        this.canConfirm = true;
      }, 2000);
    }
  },
  methods: {
    cancel() {
      if (!this.loading) {
        this.$emit("cancel");
      }
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
